export default "__VITE_ASSET__DotSexCb__"